export var MINUTES_15 = 1 / 96;
export var MINUTES_30 = 1 / 48;
